// @flow

import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import styled from "styled-components";

import A from "./A";
import Calc from "./calc";
import Milestones from "./milestones";

const NotFound = () => <div>Page not found.</div>;

export default () =>
  <BrowserRouter>
    <div>
      <Switch>
        <Redirect exact from="/" to="/calculator" />
        <Route path="/calculator" component={Calc} />
        <Route path="/milestones" component={Milestones} />
        <Route path="*" component={NotFound} />
      </Switch>
      <Footer>
        <A href="mailto:contact@onenumberup.com">
          Contact Us
        </A>
      </Footer>
    </div>
  </BrowserRouter>;

const Footer = styled.div`
  margin: 50px auto;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/App.js